import { Box, IconButton, List, ListItem, ListItemText, Paper, Tooltip, Typography } from "@mui/material";
import { colours } from "../../../../StyleConstants";
import { useDispatch, useSelector } from "react-redux";
import { adwRemoveField, adwRemoveInstrument, adwUpdateAgeGroups } from "../../dataWranglerSlice";
import { useWizardQuery } from "../../../../api/dataWranglerApiSlice";
import MultiSelect from "../../../../components/form/MultiSelect";
import { Option } from "../../../../components/form/SelectBox";
import { CancelOutlined } from "@mui/icons-material";
import { selectSelectedDatabase } from '../../../common/databaseSlice';

interface Props {
    originalData?: any;
    name: string;
    instrument: any;
    editable: boolean;
}

const ADWInstrument = (props: Props) => {
    const dispatch = useDispatch();
    const selectedDatabase = useSelector(selectSelectedDatabase);
    const {
        data,
        isFetching: loading
    } = useWizardQuery({ database: selectedDatabase });

    const removeField = (field: string) => {
        dispatch(adwRemoveField({
            instrument: props.name,
            field: field
        }))
    }

    const removeInstrument = () => {
        dispatch(adwRemoveInstrument(props.name));
    }

    const updateAgeGroups = (ageGroups: Option[]) => {
        dispatch(adwUpdateAgeGroups({
            instrument: props.name,
            ageGroups: ageGroups
        }));
    }

    if (loading) {
        return (
            <div>Loading...</div>
        );
    }

    const instrumentVisits = data?.allInstruments[props?.instrument.name]?.visitLabels ?? [];
    const ageGroups: Option[] = instrumentVisits.map((group: any) => {
        return { value: group, label: group }
    });
    const instrumentDescription = data?.allInstruments[props?.name]?.description

    return (
        <Paper
            elevation={0}
            sx={{
                backgroundColor: colours.orange.orange15,
                borderRadius: '8px',
                marginBottom: "8px",
                padding: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'self-start',
                }}
            >
                {data?.allInstruments?.[props?.instrument?.name]?.staticInstrument &&
                    <Typography fontWeight={600}
                        sx={{
                            backgroundColor: 'orange',
                            padding: '3px 8px',
                            borderRadius: "8px 0 8px 0",
                            margin: "-8px 10px 0 -8px"

                        }} fontSize="inherit"
                    >
                    S
                    </Typography>
                }
                <Typography
                    sx={{
                        flexGrow: 1,
                        flexShrink: 1,
                        marginRight: 2,
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                        wordBreak: 'break-word',
                    }}
                    variant={'h6'} fontSize={'1rem'} fontWeight={900}>
                    {instrumentDescription} - {props.instrument.name}
                </Typography>
                {props.editable &&
                    <IconButton
                        sx={{
                            flexShrink: 0,
                            flexGrow: 0,
                            width: '10%',
                        }}
                        onClick={() => removeInstrument()}>
                        <CancelOutlined fontSize="small"/>
                    </IconButton>
                }
            </Box>
            <List dense={true}>
                {Object.keys(props.instrument.fields || {}).map((field) => (
                    <ListItem key={field}>
                        {props.editable &&
                            <IconButton sx={{ width: '10%' }} onClick={() => removeField(field)}>
                                <CancelOutlined fontSize="small"/>
                            </IconButton>
                        }
                        <Tooltip title={field}>
                            <ListItemText
                                sx={{ width: '90%', overflow: 'clip' }}
                                primary={field}
                                primaryTypographyProps={{ fontSize: '0.9rem' }}
                            />
                        </Tooltip>

                    </ListItem>
                ))}
            </List>
            <MultiSelect
                label={'Sessions'}
                options={ageGroups}
                name={'ageRange'}
                onChange={updateAgeGroups}
                value={props.instrument.ageGroups}
                disabled={!props.editable}
            />
        </Paper>
    )
}

export default ADWInstrument;